import {
  GET_CART_REQUEST,
  GET_CART_SUCCESS,
  GET_CART_FAILURE,
  GET_PRODUCTS_REQUEST,
  SELECT_NEW_PACKAGE,
} from "../../constants";
import { createAction, createErrorAction } from "../../utils";

import { getPackagesInCartCount, getCartItems } from "../../selectors";
import { getUpsellProductsAndAddonPrices } from "../getUpsellProductsAndAddonPrices/getUpsellProductsAndAddonPrices";
import showError from "../showError/showError";
import { registerGTMEvent } from "../registerGTMEvent/registerGTMEvent";

// Cart
const getCartRequest = createAction(GET_CART_REQUEST);
const getCartSuccess = createAction(GET_CART_SUCCESS);
const getCartFailure = createErrorAction(GET_CART_FAILURE);

// Products
const getProductsRequest = createAction(GET_PRODUCTS_REQUEST);
const getProductsSuccess = createAction(SELECT_NEW_PACKAGE);

export const removePlanFromDomain = ({
  plan,
  domain,
  globalCartLineIndex,
  productLines,
  currency,
}) => {
  return async (dispatch, getState, { api }) => {
    let cartData;
    const cartItems = getCartItems(getState());
    const packagesInCartCount = getPackagesInCartCount(getState());

    dispatch(getCartRequest());

    // If we are removing the last cart package
    if (packagesInCartCount === 1) {
      const responseData = {};

      dispatch(getProductsRequest());

      const result = await dispatch(
        getUpsellProductsAndAddonPrices("DOMAIN_ONLY", cartItems.length),
      );

      responseData.upsellProducts = result.upsellProducts;
      responseData.addonProductPrices = result.addonProductPrices;
      responseData.highlightedUpsell = result.highlightedUpsell;

      dispatch(getProductsSuccess(responseData));
    }

    // Select the package on the backend
    await api.removePlanFromDomain(domain);

    // Get the updated cart
    try {
      cartData = await api.getCart();

      // cart is empty
      if (cartData.success === false) {
        window.sessionStorage.removeItem("ChosenPackage");
        dispatch(getCartSuccess(cartData));

        return false;
      }

      const packages = cartData.productPrices.map(
        ({ webSpaceSize }) => webSpaceSize,
      );

      // Clean up session
      // Do not keep obsolete chosen package in the session
      if (!packages.includes(window.sessionStorage.getItem("ChosenPackage"))) {
        window.sessionStorage.removeItem("ChosenPackage");
      }

      dispatch(getCartSuccess(cartData));
    } catch (err) {
      dispatch(showError("cartUpdateFailed"));
      dispatch(getCartFailure(err));
    }

    if (window.GTM) {
      const index1Based =
        typeof globalCartLineIndex === "number"
          ? globalCartLineIndex + 1 // making it 1-based
          : globalCartLineIndex; // may be undefined if triggered from outside of cart

      dispatch(
        registerGTMEvent.removeFromCart({
          product: plan,
          productLines,
          type: "package",
          index: index1Based,
          currency,
        }),
      );

      window.GTM.pushCartContents(cartData);
    }
  };
};
